var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"searchMask","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"24","height":"24","key":0},React.createElement("path",{"d":"M0 0h23.0488v23.0488H0V0z","fill":"#fff"})),React.createElement("g",{"mask":"url(#searchMask)","key":1},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.596 2.559c3.9016 0 7.0369 3.1355 7.0369 7.037s-3.1353 7.037-7.037 7.037c-3.9015 0-7.037-3.1355-7.037-7.037s3.1355-7.037 7.037-7.037zm0-2.559C4.3112 0 0 4.3114 0 9.596s4.3113 9.5959 9.596 9.5959c2.1814 0 4.1737-.7634 5.7886-1.9981l5.4616 5.4616c.4894.5097 1.2995.5263 1.8091.0369.5099-.4894.5263-1.2995.0369-1.8094a1.83 1.83 0 00-.0369-.0368l-5.4613-5.4614c1.2347-1.6149 1.9979-3.6073 1.9979-5.7887 0-5.2846-4.3114-9.596-9.596-9.596z","fill":"#005A8B"}))]);
}

Search.defaultProps = {"fill":"none","viewBox":"0 0 24 24"};

module.exports = Search;

Search.default = Search;
